import { Star } from "lucide-react"
import { useIntersectionObserver } from "../../hooks/useIntersectionObserver"
import { useKeysCountQuery } from "../../query/keysCountGet"
import { Skeleton } from "../ui/skeleton"

type FidelityPointsCellProps = {
  clientId: string
  className?: string
}

export const FidelityPointsCell = ({
  clientId,
  className = "",
}: FidelityPointsCellProps) => {
  const { elementRef, hasBeenVisible } = useIntersectionObserver({
    threshold: 0.1,
    rootMargin: "50px", // Commence à charger 50px avant d'être visible
  })

  const { keysCount, isLoading, isError, error } = useKeysCountQuery(
    { clientId },
    { enabled: hasBeenVisible } // Ne charge que quand l'élément a été visible
  )

  // Placeholder avant que l'élément ne soit visible
  if (!hasBeenVisible) {
    return (
      <div ref={elementRef} className={`flex items-center ${className}`}>
        <Star className="h-4 w-4 mr-1 text-gray-300" />
        <span className="text-sm text-gray-400">--</span>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div ref={elementRef} className={`flex items-center ${className}`}>
        <Skeleton className="h-4 w-4 mr-1 rounded" />
        <Skeleton className="h-4 w-12" />
      </div>
    )
  }

  if (isError) {
    console.error("Error loading fidelity points:", error)
    return (
      <div ref={elementRef} className={`flex items-center ${className}`}>
        <Star className="h-4 w-4 mr-1 text-red-600" />
        <span className="text-sm text-red-500">Erreur</span>
      </div>
    )
  }

  const points = keysCount?.keysNumber ?? 0

  return (
    <div ref={elementRef} className={`flex items-center ${className}`}>
      <Star className="h-4 w-4 mr-1 text-purple-600" />
      <span className="font-medium">{points} pts</span>
    </div>
  )
}
